<template>
  <div class="sticky-sm-top calculator-page__total w-100 rounded mt-5 px-4">
    <div class="card-body">
      <h4 class="text-info text-center py-2">Actions</h4>
      <div class="row py-2 hide-stuff">
        <div class="col-4">
          <h2 class="fw-bold" align="left">COP</h2>
        </div>
        <div class="col-8">
          <h2 class="fw-bold" align="right">{{ totals(cop) }}</h2>
        </div>
      </div>
      <div class="row py-2 hide-stuff">
        <div class="col-4">
          <h2 class="fw-bold" align="left">EUR</h2>
        </div>
        <div class="col-8">
          <h2 class="fw-bold" align="right">{{ totals(eur) }}</h2>
        </div>
      </div>
      <div class="row py-2 hide-stuff">
        <div class="col-4">
          <h2 class="fw-bold" align="left">USD</h2>
        </div>
        <div class="col-8">
          <h2 class="fw-bold" align="right">{{ totals(usd) }}</h2>
        </div>
      </div>
    </div>

    <div class="row py-4">
      <div class="col-2 hide-stuff">
        <h6 class="text-secondary" align="left">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.63672 5.01562H11.4648V6.63281H6.63672V11.625H5.00781V6.63281H0.203125V5.01562H5.00781V0H6.63672V5.01562Z" fill="#212A4B" fill-opacity="0.5"/>
          </svg>
        </h6>
      </div>
      <div class="col-10 hide-stuff">
        <h6 class="text-secondary" align="right">Additional requirements</h6>
      </div>
      <p class="text-secondary py-1" align="justify">
        {{action_text}}
      </p>
      <div class="d-grid gap-2" v-if="Object.keys(contact).length !== 0 && isValidEmail(contact[0]['email']) && (contact[0]['name'] !== '') && Object.keys(requirements).length !== 0">
        <div class="d-flex justify-content-center py-2 hide-stuff">
            <button type="button" class="btn btn-outline-info w-100" data-bs-toggle="modal" data-bs-target="#exampleModal">Download PDF</button>
        </div>
        <div class="d-flex justify-content-center py-2">
          <button type="submit" class="btn btn-outline-info w-100" @click="this.handleSendQuote()">
            Request Quotation
          </button>
        </div>
      </div>

      <div class="d-grid gap-2" v-else>
        <div class="d-flex justify-content-center py-2 hide-stuff">
            <button type="button" class="btn btn-outline-info w-100" @click="this.handleSendQuote()">
              Download PDF
            </button>
        </div>
        <div class="d-flex justify-content-center py-2">
          <button type="button" class="btn btn-outline-info w-100" @click="this.handleSendQuote()">
           Request Quotation
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Modal -->
  <div class="modal fade" ref="modal" id="exampleModal" tabindex="-1" aria-labelledby="ExampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="ExampleModalLabel">Please select currency</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="form-check form-check-inline px-4">
            <input class="form-check-input" type="radio" v-model="this.currency" name="currency" id="inlineCheckbox1" value="COP">
            <label class="form-check-label" for="inlineCheckbox1">COP</label>
          </div>
          <div class="form-check form-check-inline px-4">
            <input class="form-check-input " type="radio" v-model="this.currency" name="currency" id="inlineCheckbox2" value="USD">
            <label class="form-check-label" for="inlineCheckbox2">USD</label>
          </div>
          <div class="form-check form-check-inline ">
            <input class="form-check-input " type="radio" v-model="this.currency" name="currency" id="inlineCheckbox3" value="EUR">
            <label class="form-check-label" for="inlineCheckbox3">EUR</label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" @click="downloadPDF()">Save</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Toast  -->
  
  <div class="position-fixed top-0 end-0 p-3" style="z-index: 1500">
    <div id="toast" ref="toast" :class="domShowToast" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="d-flex">
        <div class="toast-body">
          {{ this.message }}
        </div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="hideToast()"></button>
      </div>
    </div>
  </div>
</template>

<script>
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import Helix from '@/img/helix.png';

export default {
  name: "Totals",
  props: {
    cop: {
      type: String,
      required: true
    },
    eur: {
      type: String,
      required: true
    },
    usd: {
      type: String,
      required: true
    },
    action_text: {
      type: String,
      required: true
    },
    requirements: {
      type: Array,
      required: true
    },
    customrequirements: {
      type: Array,
      required: true
    },
    contact: {
      type: Array,
      required: true
    },
    description: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      currency: '',
      price: '',
      total: '',
      totalCOP: '',
      totalEUR: '',
      totalUSD: '',
      message: '',
      show: '',
      timer: 0,
      emailExpressionValidate: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  computed: {
    domShowToast() {
      return `toast align-items-center text-white border-0 ${this.show}`
    }
  },

  methods: {
    showToast(message = '', type = 'error') {
      this.message = message || this.message || 'Something went wrong';

      if (type === 'success') {
        this.show = 'show bg-success'; 
      } else {
        this.show = 'show bg-warning'; 
      }

      if (this.timer) clearTimeout(this.timer);

      const duration = type === 'success' ? 5000 : 3500;
      this.timer = setTimeout(() => (this.show = ''), duration);
    },

    hideToast() {
      this.show = '';
    },

    validateContact() {
      if (!this.contact.length) return 'Please fill the contact fields';
      if (!this.contact[0].name) return 'Please fill the contact name field';
      if (!this.contact[0].email) return 'Please fill the contact email field';
      if (!this.contact[0].phone) return 'Please fill the contact phone field';
      if (!this.contact[0].name_enterprise) return 'Please fill the contact name enterprise field';
      if (!this.description) return 'Please fill the description field';
      if (!this.isValidEmail(this.contact[0].email)) return 'Please include @ and . in email';
      return '';
    },

    validateRequirement() {
      if (!Object.keys(this.requirements).length) return 'Please select at least one requirement';
      return '';
    },

    handleSendQuote() {
      const contactError = this.validateContact();
      const reqError = this.validateRequirement();

      if (contactError || reqError) {
        this.showToast(contactError || reqError, 'error');
        return;
      }

      this.showToast('Quote sent successfully!', 'success');
    },

    isValidEmail(email) {
      return this.emailExpressionValidate.test(email);
    },

    totals(value) {
      let total = '';
      for (const i in this.requirements) {
        total = (Number(this.requirements[i].hours) + Number(total));
        let valueWithSeparators = 0;
        valueWithSeparators = this.thousandsSeparator(Number(this.requirements[i].hours)*Number(value));
        Object.assign(this.requirements[i],{price : valueWithSeparators});
      }
      total = this.thousandsSeparator(Number(total) * Number(value));
      this.total = total;
      return total;
    },

    toJSON(object) {
      object = JSON.stringify(object);
      return object
    },

    thousandsSeparator(valueToSeparate) {
      return valueToSeparate.toLocaleString("da-DK");
    },

    downloadPDF() {
      const fecha = new Date();
      const doc = new jsPDF('p', 'pt');
      const img = new Image();
      img.src = Helix;

      doc.setFontSize(22);
      doc.addImage(img, 'JPEG', 50, 25);
      doc.text('Helix', 120, 70);
      doc.setFontSize(10);
      doc.text('NIT: 901451693 ', 70, 115);
      doc.text(fecha.toDateString(), 70, 130);


      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("Customer Name:", 70, 150);

      doc.setFont("helvetica", "normal");
      doc.text(String(this.contact[0].name || ''), 170, 150);

      doc.setFont("helvetica", "bold");
      doc.text("Email:", 70, 175);
      doc.setFont("helvetica", "normal");
      doc.text(String(this.contact[0].email || ''), 110, 175);

      const disclaimer = `
      Este documento es una cotización aproximada para la construcción del proyecto
      según los requerimientos actualmente definidos. Los costos asociados a
      requerimientos adicionales, cambios en el alcance o nuevas funcionalidades
      podrán variar en función de la complejidad, tiempo de desarrollo y recursos
      necesarios. Esta cotización no constituye un contrato vinculante, sino una guía
      estimada para la planificación y toma de decisiones.
      `;

      doc.setFontSize(10);
      doc.setTextColor(100);
      const textLines = doc.splitTextToSize(disclaimer, 480);
      const textHeight = textLines.length * 10;

      doc.text(textLines, 60, 200, { maxWidth: 480, align: "left" });
      const startTableY = 200 + textHeight + 10;

      if (this.currency === 'COP') this.totals(this.cop);
      if (this.currency === 'EUR') this.totals(this.eur);
      if (this.currency === 'USD') this.totals(this.usd);

      const reqs = this.requirements.map(r => ({
        name: r.name || '', 
        price: r.price || ''
      }));

      reqs.push({ name: 'TOTAL', price: this.thousandsSeparator(this.total) });

      autoTable(doc, {
        startY: startTableY,
        head: [[ "Requirements", "Price " + this.currency ]],
        body: reqs.map(r => [r.name, r.price]),
        margin: { top: startTableY, bottom: 20 },
      });

      if (this.customrequirements.length > 0) {
        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 30,
          head: [[ "+ ADDITIONAL REQUIREMENTS" ]],
          body: this.customrequirements.map(c => [c.requirement]),
        });
      }

      doc.setFontSize(50);
      doc.text('Quotation', 300, 110);
      doc.save('quotation.pdf');
    }
  }
}
</script>

<style lang="scss">
.toast {
  transition: opacity 1.5s ease;
}

.show {
  transition: none;
}

.btn-close:focus {
  outline: none !important;
  box-shadow: none !important;
}

.hide-stuff{
  display: none !important;
}
</style>
